import { render, staticRenderFns } from "./MunicipalityLogo.vue?vue&type=template&id=2ee451b9&"
import script from "./MunicipalityLogo.vue?vue&type=script&lang=js&"
export * from "./MunicipalityLogo.vue?vue&type=script&lang=js&"
import style0 from "./MunicipalityLogo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports